import { Controller } from "@hotwired/stimulus";
import mapboxgl, { Marker } from "mapbox-gl";

export default class extends Controller {
  static values = {
    centerLat: Number,
    centerLng: Number,
    color: String,
    markers: Array,
  };
  static targets = ["map"];

  connect() {
    mapboxgl.accessToken =
      "pk.eyJ1IjoibXJ3aWxsaWhvZyIsImEiOiJjbDI5YzRwZzkwMnNwM2NvNGY4aHh4eWR2In0.W4Eu3eTXf7XRC0e5K47zLw";
    this.initMap();
  }

  initMap() {
    const bounds = new mapboxgl.LngLatBounds();

    this.markersValue.forEach((marker) => {
      bounds.extend([marker.lng, marker.lat]);
    });

    const params = {
      container: this.mapTarget,
      style: "mapbox://styles/mapbox/outdoors-v11",
      attributionControl: false,
      logoPosition: "bottom-right",
      center: [this.centerLngValue, this.centerLatValue],
      zoom: 10,
    };

    const map = new mapboxgl.Map(params);
    map.scrollZoom.disable();
    map.addControl(new mapboxgl.NavigationControl(), "top-right");
    map.addControl(
      new mapboxgl.GeolocateControl({
        showUserLocation: false,
      }),
      "top-right"
    );

    this.markersValue.forEach((marker) => {
      const popup = new mapboxgl.Popup({
        closeButton: false,
        closeOnClick: false,
      }).setHTML(`<strong>${marker.name}</strong>${marker.sighting_count ? `<br>${marker.sighting_count} sightings` : ""}`);

      new Marker({
        draggable: false,
        color: `#${this.colorValue}`,
      })
        .setLngLat([marker.lng, marker.lat])
        .setPopup(popup)
        .addTo(map);
    });

    if (this.markersValue.length > 1) {
      map.fitBounds(bounds, { padding: 50 });
    }

    map.on("load", function () {
      map.resize();
    });

    this.map = map;
  }
}
